import * as React from 'react';

export enum RelativeToViewportPosition {
    higher = 'higher',
    lower = 'lower',
    inside = 'inside'
}

export const getRelativeToViewportPosition = (
    node: Element,
    viewport: Element
): RelativeToViewportPosition => {
    const nodeRect = node.getBoundingClientRect();
    const viewportRect = viewport.getBoundingClientRect();

    if (nodeRect.top < viewportRect.top) {
        return RelativeToViewportPosition.higher;
    }

    if (nodeRect.bottom > viewportRect.bottom) {
        return RelativeToViewportPosition.lower;
    }

    return RelativeToViewportPosition.inside;
};

export function parseHtmlFromString(str: string): HTMLElement {
    const parser = new DOMParser();

    const doc = parser.parseFromString(str, 'text/html');

    return doc.body.firstChild as HTMLElement;
}

const preventScrollListener = function(
    this: HTMLElement,
    event: WheelEvent
): void {
    // We don't want to scroll below zero or above the width and height
    const maxX = this.scrollWidth - this.offsetWidth;
    const maxY = this.scrollHeight - this.offsetHeight;

    // If this event looks like it will scroll beyond the bounds of the element, prevent it and set the scroll to the boundary manually
    if (
        this.scrollLeft + event.deltaX < 0 ||
        this.scrollLeft + event.deltaX > maxX ||
        this.scrollTop + event.deltaY < 0 ||
        this.scrollTop + event.deltaY > maxY
    ) {
        event.preventDefault();

        // Manually set the scroll to the boundary
        this.scrollLeft = Math.max(
            0,
            Math.min(maxX, this.scrollLeft + event.deltaX)
        );
        this.scrollTop = Math.max(
            0,
            Math.min(maxY, this.scrollTop + event.deltaY)
        );
    }
};

// @see https://stackoverflow.com/questions/8737709/any-way-to-prevent-horizontal-scrolling-triggering-swipe-back-gesture-on-os-x-li
export function preventMacOsNavigationGesture(
    element: HTMLElement
): () => void {
    // Add the event listener which gets triggered when using the trackpad
    element.addEventListener('mousewheel', preventScrollListener, false);

    return function unsubscribe(): void {
        return element.removeEventListener(
            'mousewheel',
            preventScrollListener,
            false
        );
    };
}

export function isMacDevice(): RegExpMatchArray | null {
    return navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i);
}

export const PopupScopeContext = React.createContext<() => HTMLElement>(
    () => document.body
);

export const AppScrollNode = React.createContext<() => HTMLElement>(
    () => document.body
);

export function scrollToNode(parentNode: HTMLElement, node: HTMLElement): void {
    const scrollHeight = node.offsetTop - parentNode.offsetTop;
    parentNode.scrollTop = scrollHeight;
}
